import script from "./Badge3d.vue?vue&type=script&setup=true&lang=js"
export * from "./Badge3d.vue?vue&type=script&setup=true&lang=js"

import "./Badge3d.vue?vue&type=style&index=0&id=209da588&scoped=true&lang=css"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-209da588"]])

export default __exports__